import { useDrag } from '@use-gesture/react'
import { useState } from 'react'
import resizeArrowIcon from '../../icons/resize_arrow.svg'
import { GestureOverlayContainer } from './GestureOverlayContainer'
import { useOnResize, useOnScale } from './hooks'
import './styles.css'
import { ResizeProps } from './types'

type ResizeOverlayProps = ResizeProps & {
  zoom: number
}

export const ScaleModeBody = ({
  zoom,
  value,
  min,
  max,
  constrainAspectRatio,
  onResize,
  onDragStart,
  onDragEnd,
}: Omit<ResizeOverlayProps, 'mode'>) => {
  const [isDragging, setIsDragging] = useState(false)

  const onScale = useOnScale(
    value,
    min,
    max,
    !!constrainAspectRatio,
    zoom,
    () => {
      setIsDragging(true)
      onDragStart?.()
    },
    () => {
      setIsDragging(false)
      onDragEnd?.()
    },
    onResize,
  )

  const bind = useDrag(onScale)

  return (
    <div style={{ cursor: isDragging ? 'grabbing' : 'grab' }} {...bind()} className="resize-handle">
      <img src={resizeArrowIcon} height="16px" width="16px" alt="resize" draggable={false} />
    </div>
  )
}
export const ResizeModeBody = ({
  value,
  zoom,
  min,
  max,
  constrainAspectRatio,
  onResize,
  onDragStart,
  onDragEnd,
}: Omit<ResizeOverlayProps, 'mode'>) => {
  const [isDragging, setIsDragging] = useState(false)

  const onResizeDrag = useOnResize(
    value,
    min,
    max,
    !!constrainAspectRatio,
    zoom,
    () => {
      setIsDragging(true)
      onDragStart?.()
    },
    () => {
      setIsDragging(false)
      onDragEnd?.()
    },
    onResize,
  )

  const bind = useDrag(onResizeDrag)

  return (
    <div style={{ cursor: isDragging ? 'grabbing' : 'grab' }} {...bind()} className="resize-handle">
      <img src={resizeArrowIcon} height="16px" width="16px" alt="resize" draggable={false} />
    </div>
  )
}

export const ResizeBody = ({ mode, ...props }: ResizeOverlayProps) => {
  switch (mode) {
    case 'scale':
      return <ScaleModeBody {...props} />
    case 'resize':
      return <ResizeModeBody {...props} />
    default:
      throw new Error(`Unknown resize mode: ${mode}`)
  }
}

export const ResizeOverlay = (props: ResizeOverlayProps) => (
  <GestureOverlayContainer>
    <ResizeBody {...props} />
  </GestureOverlayContainer>
)
